'use strict';

import $ from 'jquery';

const jqueryValidation = require('jquery-validation');

export default class Header {
  constructor() {
    this.changeLanguage();
    // Login Form validation
    $('#floatingLoginForm').validate();

    // Mobile menu events
    $('*[data-js="openMenu"]').on('click', (event) => {
      event.preventDefault();
      this.openMenu();
    });
    $('*[data-js="sidenavOverlay"]').on('click', () => {
      event.preventDefault();
      this.closeMenu();
    });
    $('*[data-js="closeMenu"]').on('click', () => {
      event.preventDefault();
      this.closeMenu();
    });
    // Mobile search events
    $('*[data-js="mobileSearchInput"] > input').on('keyup', (event) => {
      if (event.target.value.length > 0) {
        $('*[data-js="resetMobileSearchInput"]').show();
      }else{
        $('*[data-js="resetMobileSearchInput"]').hide();
      }
    });
    $('*[data-js="resetMobileSearchInput"]').on('click', () => {
      $('*[data-js="mobileSearchInput"] > input')
        .val('')
        .focus();
      $('*[data-js="resetMobileSearchInput"]').hide();
    });
    // Login box
    $('*[data-js="openLoginBox"]').on('click', (event) => {
      event.preventDefault();
      const $target = $(event.delegateTarget);
      if ( $target.hasClass('open') ){
        this.closeLoginBox();
      }else{
        this.openLoginBox();
      }
      $target.toggleClass('open');
    });

    // Serach box
    $('*[data-js="search-icon"]').on('click', (event) => {
      $(event.delegateTarget).addClass('open');
      $(event.delegateTarget).find('input').focus();
    });
    $('*[data-js="header-input-search"]').on('blur', () => {
      $('*[data-js="search-icon"]').removeClass('open');
    });
  }

  openMenu() {
    $('*[data-js="sidenavOverlay"]')
        .css('opacity',1)
        .css('display','block');
    $('#mySidenav')
      .delay(300)
      .addClass('show');
  }

  closeMenu() {
    $('*[data-js="sidenavOverlay"]')
        .fadeTo(300, 0, () => {
          $('*[data-js="sidenavOverlay"]').css('display','none');
        });
    $('#mySidenav')
      .delay(500)
      .removeClass('show');
  }

  openLoginBox() {
    const $loginBox = $('#loginBox');
    $loginBox.slideDown();
  }
  closeLoginBox() {
    const $loginBox = $('#loginBox');
    $loginBox.slideUp();
  }


  changeLanguage() {
    $.extend( $.validator.messages, {
      required: 'Este campo es obligatorio.',
      remote: 'Por favor, rellena este campo.',
      email: 'Por favor, escribe una dirección de correo válida.',
      url: 'Por favor, escribe una URL válida.',
      date: 'Por favor, escribe una fecha válida.',
      dateISO: 'Por favor, escribe una fecha (ISO) válida.',
      number: 'Por favor, escribe un número válido.',
      digits: 'Por favor, escribe sólo dígitos.',
      creditcard: 'Por favor, escribe un número de tarjeta válido.',
      equalTo: 'Por favor, escribe el mismo valor de nuevo.',
      extension: 'Por favor, escribe un valor con una extensión aceptada.',
      maxlength: $.validator.format( 'Por favor, no escribas más de {0} caracteres.' ),
      minlength: $.validator.format( 'Por favor, no escribas menos de {0} caracteres.' ),
      rangelength: $.validator.format( 'Por favor, escribe un valor entre {0} y {1} caracteres.' ),
      range: $.validator.format( 'Por favor, escribe un valor entre {0} y {1}.' ),
      max: $.validator.format( 'Por favor, escribe un valor menor o igual a {0}.' ),
      min: $.validator.format( 'Por favor, escribe un valor mayor o igual a {0}.' ),
      nifES: 'Por favor, escribe un NIF válido.',
      nieES: 'Por favor, escribe un NIE válido.',
      cifES: 'Por favor, escribe un CIF válido.'
    } );
  }
}
